import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';

export default function TotalTimeMaskedInput(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[1-9]/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/]}
      placeholderChar={'0'}
      showMask
    />
  );
}

TotalTimeMaskedInput.propTypes = {
  inputRef: PropTypes.func.isRequired
};
